<template>
  <v-container grid-list-md text-center>
    <v-layout wrap>
      <v-flex xs2>
      </v-flex>
      <v-flex v-if="isLoading">
        <v-text-field color="primary" loading disabled></v-text-field>
      </v-flex>
      <v-flex xs8 v-else>
        <v-layout justify-center>
          <v-card>
            <v-form ref="form" v-model="validate" lazy-validation>
              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-card-title class="text-center justify-center display-1 primary--text">Empréstimos</v-card-title>
                    <v-card-title class="text-center justify-center headline blue--text">Insira o valor da proposta</v-card-title>
                    <v-text-field v-model.lazy="amount" v-money="money" label="Valor" background-color="#ffffff" color="black" solo class="text-center justify-center headline white--text"></v-text-field>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="validate">Enviar</v-btn>
                    </v-card-actions>
                  </v-flex>
                  <v-card-text>
                    <v-tabs
                      background-color="transparent"
                      color="transparent accent-4"
                      centered
                      dark
                      icons-and-text
                    >
                      <v-tabs-slider></v-tabs-slider>

                      <v-tab class="blue--text">
                        Agenda de Recebíveis
                        <v-icon class="blue--text">calendar_today</v-icon>
                      </v-tab>

                      <v-tab-item>
                        <v-layout align-center wrap>
                          <v-flex xs12>
                            <v-card flat color="blue" min-height='400'>
                              <v-card-title class="text-center justify-center headline white--text" v-for="item in (lends[0]['liquidation_schedule'][0])">Data: {{item.referencia}} Valor: R$ {{formatValue(item.valor)}}</v-card-title>
                              <v-card-title class="text-center justify-center headline white--text">Total: R$ {{formatValue(lends[0]['liquidation_schedule'][1]['total'])}}</v-card-title>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>
                    </v-tabs>
                  </v-card-text>
                </v-layout>
              </v-container>
            </v-form>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex xs2>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';
import {VMoney} from 'v-money';
import { format } from 'path';
import { changed } from '@/helpers/layout';
import {mask} from 'vue-the-mask';

export default {
  created() {
    this.$store.dispatch('account/getAccountLends');
    const self = this;
  },
  computed: {
    ...mapGetters({
      lends: 'account/accountLends',
      isLoading: 'account/loading'
    }),
  },
  watch: {

  },
  data() {
    return {
      amount: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
    };
  },
  directives: {money: VMoney},
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.lends = {
          amount: this.amount,
        }
        this.$store.dispatch('account/newLend', this.payment)
        this.alert = this.isLoading
        this.$refs.form.reset()
      }
    },
    formatValue (value) {
      return value.toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    },
  },
  components: {

  },
};
</script>
